// Guides archive (.tp-guides) — чипсы-фильтр категорий, клиентский, как в
// макете Blog General. Guarded: работает только на archive-guide.php.
// Бургер и плавные якоря шапки обрабатывает default-page.js (guard .tp-default).
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-guides');
    if (!root) {
        return;
    }

    var chips = root.querySelectorAll('.tp-guides__chip');
    var cards = root.querySelectorAll('.tp-gcard');
    var empty = root.querySelector('.tp-guides__empty');

    chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
            var filter = chip.getAttribute('data-filter') || '';

            chips.forEach(function (c) { c.classList.remove('is-active'); });
            chip.classList.add('is-active');

            var visible = 0;
            cards.forEach(function (card) {
                var show = !filter || card.getAttribute('data-category') === filter;
                card.classList.toggle('is-hidden', !show);
                if (show) {
                    visible++;
                }
            });

            if (empty) {
                empty.hidden = visible > 0;
            }
        });
    });
});
